import { Image as ImageIcon, Loader2 } from 'lucide-react'
import { useFileThumbnailUrl } from '../files/hooks'

type Props = {
  contractId: number
  fileId: number
  filename: string
  onClick: () => void
}

/**
 * Miniaturka obrazka 48x48 - używana w kafelku pojedynczego pliku FILE.
 * Klik woła {@code onClick} (zwykle otwiera lightbox). Pre-signed URL z R2
 * jest cache'owany 5 minut.
 */
export function FileImageThumb({ contractId, fileId, filename, onClick }: Props) {
  // 48px slot w UI; bierzemy 200px ze względu na retina (48 × ~2x).
  const urlQ = useFileThumbnailUrl(contractId, fileId, 200)
  return (
    <button
      type="button"
      onClick={onClick}
      className="h-full aspect-square rounded overflow-hidden bg-slate-100 border border-slate-200 hover:ring-2 hover:ring-sky-400 transition shrink-0 relative"
      title="Kliknij aby powiększyć"
    >
      {urlQ.isLoading ? (
        <div className="absolute inset-0 flex items-center justify-center text-slate-400">
          <Loader2 size={14} className="animate-spin" />
        </div>
      ) : urlQ.data ? (
        <img
          src={urlQ.data.url}
          alt={filename}
          className="w-full h-full object-cover"
          loading="lazy"
        />
      ) : (
        <div className="absolute inset-0 flex items-center justify-center text-slate-400">
          <ImageIcon size={16} />
        </div>
      )}
    </button>
  )
}
